module.exports = __webpack_public_path__ + "static/media/DP_Embroidery_Meda_Ind.Blue_Peri.58b70bca.png";